module.exports = __webpack_public_path__ + "img/rg_saude_transp_logo_only.20d60b52.png";